/*eslint-disable*/
import React, { useState, useEffect, useContext, Alert } from "react";
import MaterialTable from "material-table";
import CircularLoading from "../../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from "../../components/ConfirmationDialogRaw";
import { features, dateStyle, language } from "config";
import Material_React_Table from "../../components/React_Material_Table/Material_React_Table";
import { Box } from "@mui/material";
import { FirebaseContext } from "common";

const FinancialReport = () => {
  const { api } = useContext(FirebaseContext);
  const { fetchBookings } = api;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const usersdata = useSelector((state) => state.doctors);
  const [role, setRole] = useState(null);
  const [data, setData] = useState([]);
  const [user, setUser] = useState([]);
  const [Doctors, setDoctors] = useState([]);
  let [columns, setColumn] = useState([]);

  const bookinglistdata = useSelector(
    (state) => state.bookinglistdata.bookings
  );
  useEffect(() => {
    console.log("Booking data ", bookinglistdata);
    if (bookinglistdata !== null) {
      setData(bookinglistdata);
    } else if (bookinglistdata === null) {
      setData([]);
    }
  }, []);

  columns = [
    // {
    //   header: "Invoice No",
    // },
    {
      header: "Patient Name",
      accessorKey: "patientName",
      render: (rowData) => rowData.patientName,
    },
    {
      header: "Treatment Fee",
      accessorKey: "treatmentFee",
      render: (rowData) => rowData.estimate_treatment_fee,
    },

    {
      header: "Discount",
      accessorKey: "discount",
      render: (rowData) => rowData.discount,
    },

    {
      header: "Dispensing Fee",
      accessorKey: "dispensingFee",
      render: (rowData) => rowData.estimate_treatment_fee,
    },

    {
      header: "Consultation Fee",
      accessorKey: "consultationFee",
    },
    ///service fee, grand total, Fare cost

    {
      header: "Fare Cost",
      accessorKey: "fareCost",
    },

    {
      header: "Total",
      accessorKey: "grandTotal",
      render: (rowData) => rowData.estimate_bigGrand,
    },

    {
      header: "Paid On",
      accessorKey: "paidOn",
      render: (rowData) => rowData.bookingDate,
    },

    {
      header: "Payment Type",
      accessorKey: "paymentType",
      //render: (rowData) => rowData.bookingDate,
    },
    {
      header: "Payment Amount",
      accessorKey: "paymentAmount",
      // render: (rowData) => rowData.bookingDate,
    },

    {
      header: "Status",
      accessorKey: "status",
      // render: (rowData) => rowData.bookingDate,
    },

    // { header: "View/Print" },
    //{ title: "Status", field: "status", render: rowData => rowData.status },
    // { title: 'Follow Up' },  this is optional
  ];

  useEffect(() => {
    let arr = [];
    usersdata.users.map((user) => {
      if (
        user.practiceNumber === auth.info.profile.practiceNumber &&
        user.userType === "doctor"
      ) {
        arr.push({
          firstName: user.firstName,
          lastName: user.lastName,
          mobile: user.mobile,
          email: user.email,
          uid: user.id,
          profile_image: user.profile_image,
          desc:
            user.firstName +
            " " +
            user.lastName +
            " (" +
            user.mobile +
            ") " +
            user.email,
          pushToken: user.pushToken,
        });
      }
    });
    setDoctors(arr);
  }, []);

  return (
    <div>
     <Box>
    {/* <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
      {commonAlert.msg}
    </AlertDialog> */}
    <Material_React_Table
      data={data}
      columns={columns}
      userInitialState={{
        columnVisibility: { id: false }, // This hides the "id" column initially
      }}
      onRowAdd={onRowAdd}
      onRowUpdate={onRowUpdate}
      onRowDelete={onRowDelete}
    />
  </Box>
    </div>
  );
};

export default FinancialReport;
